import { IsString } from 'class-validator';

export class CreateCustomer {
  @IsString()
  id: string;
}
